import React, { Component } from 'react';
import { Fragment } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.scss';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom'
import { saveProductReview } from '../../../actions/productReview';
import { toast } from 'react-toastify';

class DetailsTopTabs extends Component {
    constructor() {
        super();
        this.state = {
            reviewTitle: "",
            reviewComment: ""
        }
    }

    handleChange(event) {
        this.setState({ [event.target.id]: event.target.value });
    }

    handleSubmitReview(event) {
        event.preventDefault();
        if (this.props.isAuth) {
            const { connection_id, consumer_mobile_no, consumer_email_id, item } = this.props
            const options = {
                connection_id,
                consumer_mobile_no,
                consumer_email_id,
                sku_code: item.QOL_SKU_CD,
                comment: this.state.reviewComment
            }
            this.props.saveProductReview(options)
        }
        else {
            toast.error("Please login to submit review");
        }
    }

    render() {
        const { item, productAdditionalInfo, tab_enabled_flag } = this.props;
        return (
            <>
            {/* <section className="tab-product m-0" style={{paddingTop:10}} >
                <div className="row">
                    <div className="col-sm-12 col-lg-12">
                        <Tabs className="tab-content nav-material">
                            <TabList className="nav nav-tabs nav-material">
                                <Tab className="nav-item">
                                    <span className="nav-link" >
                                        <i className="icofont icofont-contacts"></i>Write Review</span>
                                    <div className="material-border"></div>
                                </Tab>
                                {item.MHM_IMAGE_VIDEO_FILE_NAME ?
                                    <Tab className="nav-item">
                                        <span className="nav-link" >
                                            <i className="icofont icofont-contacts"></i>Video</span>
                                        <div className="material-border"></div>
                                    </Tab>
                                    : ''}
                                {
                                    productAdditionalInfo && productAdditionalInfo.map(info => {
                                        return (
                                            <Tab className="nav-item">
                                                <span className="nav-link" >
                                                    <i className="icofont icofont-contacts"></i>{info.PSH_ATT_DESC}</span>
                                                <div className="material-border"></div>
                                            </Tab>
                                        )
                                    })
                                }
                            </TabList>
                            {
                                productAdditionalInfo && productAdditionalInfo.map(info => {
                                    return (
                                        item.MHM_IMAGE_VIDEO_FILE_NAME ?
                                            <TabPanel>
                                                <div className="mt-4 text-center">
                                                    <div className="embed-responsive embed-responsive-21by9">
                                                        <iframe
                                                            src={item.MHM_IMAGE_VIDEO_FILE_NAME}
                                                            allow="autoPlay; encrypted-media"
                                                            allowFullScreen>
                                                        </iframe>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                            : 
                                        <TabPanel>
                                            <form className="theme-form mt-4" onSubmit={(e) => this.handleSubmitReview(e)}>
                                                <div className="form-row">
                                                    <div className="col-md-12">
                                                        <label htmlFor="review">Comment</label>
                                                        <textarea id={info.PSD_ATT_VALUE_DESC} className="form-control" placeholder="Information Missing" rows="6" readOnly>
                                                            {info.PSD_ATT_VALUE_DESC}
                                                        </textarea>
                                                    </div>
                                                </div>
                                            </form>
                                        </TabPanel>
                                    )
                                })
                            }

                            <TabPanel>
                                <form className="theme-form mt-4" onSubmit={(e) => this.handleSubmitReview(e)}>
                                    <div className="form-row">
                                        <div className="col-md-12">
                                            <label htmlFor="review">Review Title</label>
                                            <input id="reviewTitle" type="text" className="form-control" id="review" placeholder="Enter your Review Subjects" onChange={(e) => this.handleChange(e)}     />
                                        </div>
                                        <div className="col-md-12">
                                            <label htmlFor="review">Comment</label>
                                            <textarea id="reviewComment" className="form-control" placeholder="Write Your Comments Here" id="exampleFormControlTextarea1" rows="6" onChange={(e) => this.handleChange(e)} required></textarea>
                                        </div>
                                        <div className="col-lg-12">
                                            <button className="btn btn-solid" type="submit" >Submit Your Review</button>
                                        </div>
                                    </div>
                                </form>
                            </TabPanel>
                             {item.MHM_IMAGE_VIDEO_FILE_NAME ?
                                <TabPanel>
                                    <div className="mt-4 text-center">
                                        <div className="embed-responsive embed-responsive-21by9">
                                            <iframe
                                                src={item.MHM_IMAGE_VIDEO_FILE_NAME}
                                                allow="autoplay; encrypted-media"
                                                allowFullScreen>
                                            </iframe>
                                        </div>
                                    </div>
                                </TabPanel>
                                : ''} 
                        </Tabs>
                    </div>
                </div>
            </section> */}
            
            {/* Vertical Tabs */}
        
                        
                    {Object.keys(item).length > 0 && Object.keys(productAdditionalInfo).length > 0 ? 

            <section className="tab-product m-0 vertical-tab" style={{paddingTop:10}}>
            { productAdditionalInfo && productAdditionalInfo.map((info, index) => {
                return (
                info.PSD_ATTRIBUTE_VALUE_TYPE === 'I' ?
              
     <div className='row'><div className='col-sm-12'>  
              <img src={info.PSD_ATT_VALUE_DESC} style={{width:'-webkit-fill-available'}}/></div></div>
              
              
            
            :  
               
                <div className="p-0 container" style={{width:'90%'}}>
                <Tabs className="tab-content nav-material">
                    
                   
                    
                    <div className={tab_enabled_flag !== 'N' && "tab-border row"} style={tab_enabled_flag !== 'N' ?{border:'none'}:{display:'none'}}>
                        <div className="p-0 col-xl-2">
                            <TabList className="nav nav-tabs nav-material flex-column nav-border nav">
                              {/*   {tab_enabled_flag !== 'N' && 
                                <Tab className="nav-item">
                                    <span className="nav-link" >
                                        <i className="icofont icofont-contacts"></i>Write Review</span>
                                    <div className="material-border"></div>
                                </Tab>
                                } */}
                                {item.MHM_IMAGE_VIDEO_FILE_NAME ?
                                    <Tab className="nav-item">
                                        <span className="nav-link" >
                                            <i className="icofont icofont-contacts"></i>Video</span>
                                        <div className="material-border"></div>
                                    </Tab>
                                    : ''}
                                
                                   
                    

                                            {info.PSH_ATT_DESC === 'Available Offers' ? '' :
                                            <Tab className="nav-item" key={index}>
                                                <span className="nav-link" >
                                                    <i className="icofont icofont-contacts"></i>{info.PSH_ATT_DESC}</span>
                                                <div className="material-border"></div>
                                            </Tab>
            }
                                        
                                
                                
                            </TabList>
                        </div>
                        <div className="col-xl-10">
                        {/* {tab_enabled_flag !== 'N' && 
                        <TabPanel>
                                <form className="theme-form mt-4" onSubmit={(e) => this.handleSubmitReview(e)}>
                                    <div className="form-row">
                                        <div className="col-md-12">
                                            <label htmlFor="review">Review Title</label>
                                            <input id="reviewTitle" type="text" className="form-control" id="review" placeholder="Enter your Review Subjects" onChange={(e) => this.handleChange(e)}     />
                                        </div>
                                        <div className="col-md-12">
                                            <label htmlFor="review">Comment</label>
                                            <textarea id="reviewComment" className="form-control" placeholder="Write Your Comments Here" id="exampleFormControlTextarea1" rows="6" onChange={(e) => this.handleChange(e)} required></textarea>
                                        </div>
                                        <div className="col-lg-12">
                                            <button className="btn btn-solid" type="submit" >Submit Your Review</button>
                                        </div>
                                    </div>
                                </form>
                            </TabPanel>
                            } */}
                             {item.MHM_IMAGE_VIDEO_FILE_NAME ?
                                <TabPanel>
                                    <div className="mt-4 text-center">
                                        <div className="embed-responsive embed-responsive-21by9">
                                            <iframe
                                                src={item.MHM_IMAGE_VIDEO_FILE_NAME}
                                                allow="autoplay; encrypted-media"
                                                allowFullScreen>
                                            </iframe>
                                        </div>
                                    </div>
                                </TabPanel>
                                : ''} 
                                {
                               
                                    
                                        item.MHM_IMAGE_VIDEO_FILE_NAME ?
                                            <TabPanel key={index}>
                                                <div className="mt-4 text-center">
                                                    <div className="embed-responsive embed-responsive-21by9">
                                                        <iframe
                                                            src={item.MHM_IMAGE_VIDEO_FILE_NAME}
                                                            allow="autoPlay; encrypted-media"
                                                            allowFullScreen>
                                                        </iframe>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                            : 
                                            info.PSH_ATT_DESC === 'Available Offers' ? '' :
                                        <TabPanel key={index}>
                                            <form className="theme-form mt-4" onSubmit={(e) => this.handleSubmitReview(e)}>
                                                <div className="form-row">
                                                    <div className="col-md-12">
                                                        
                                                   <ul className='list'> {info.PSD_ATT_VALUE_DESC.split('\n').map((item, key) => {
                                                       
  return <Fragment key={key}><li>&nbsp;{item}</li><br/></Fragment>
})}     </ul>
                                                        {/* <label htmlFor="review">Comment</label> */}
                                                        {/* <textarea id={info.PSD_ATT_VALUE_DESC} className="form-control" placeholder="Information Missing" rows="6" readOnly> */}
{/*                                                         
                                                       { info.PSD_ATT_VALUE_DESC.split("\n").join("<br />")}
                                                            {info.PSD_ATT_VALUE_DESC.replace(/(?:\r\n|\r|\n)/g, '<br>')} */}
                                                        {/* </textarea> */}
                                                    </div>
                                                </div>
                                            </form>
                                        </TabPanel>
                                                        
                                    
                                
                            }

                            
                        </div>
                    </div>  
                </Tabs>
                </div>
                )} )}
            </section>
            : '' }
            
              
            {/* End Verital Tabs */}
            </>
        )
    }

    
}

const mapStateToProps = (state) => ({
    isAuth: state.user.isAuth,
    connection_id: state.tenant.connection_id,
    consumer_mobile_no: state.user.user_details && state.user.user_details.COM_CONSUMER_MOBILE_NO,
    consumer_email_id: state.user.user_details && state.user.user_details.COM_EMAIL_ID
})

const mapDispatchToProps = dispatch => bindActionCreators({
    saveProductReview,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(DetailsTopTabs);